exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3X-DF{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:fixed;top:0;right:0;width:25px;height:100%;padding:0 25px;z-index:10}._3X-DF span{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;padding-left:240px;padding-left:15rem;color:#00dcb2;font-size:19.2px;font-size:1.2rem;-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg);white-space:nowrap}", ""]);

// exports
exports.locals = {
	"sidebar": "_3X-DF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"minimize":true,"discardComments":{"removeAll":true},"localIdentName":"[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/components/Sidebar/Sidebar.scss
// module id = 752
// module chunks = 2